/* global Sys, Services, Resources */
Sys.ns("Services");

/**
 * ### BalanceId
 *
 * Provide functionality to handle Balance Id change from OSS.
 *
 */
Services.IntegrationBalanceId = {

    /**
    * Initialize BlanceId object.
    *
    * @param {Object} integration Integration module.
    *
    * @returns {this} BalanceId object.
    */
    init: function(integration) {
        this._on = integration.on.bind(integration);
        this._fireEvent = integration.fireEvent.bind(integration);

        this.setupEvents();

        return this;
    },

    /**
    * Setup event listeners.
    *
    * @returns {void}
    */
    setupEvents: function() {
        this._on({
            "notify:integrationBalanceId.responseParsed": this.onResponseParsed.bind(this)
        });
    },

    /**
    * Request services reinit.
    *
    * @param {Object} parsedResponse Parsed response.
    *
    * @returns {void}
    */
    requestServicesReInit: function(parsedResponse) {
        Services.win.updateResponse(parsedResponse);
        Services.bet._freeRoundsSettingsUpdate();
        Services.moneyManager.onFreeRoundsReInit();
        Services.freeRounds._onReInitResponseReceived(parsedResponse);
    },

    /**
    * Request modules reInit.
    *
    * @param {Object} parsedResponse Parsed response.
    *
    * @returns {void}
    */
    requestModulesReInit: function(parsedResponse) {
        this._fireEvent("notify:freeRounds.reInitResponseReceived", parsedResponse);
    },

    /**
    * Notify modules about a new response.
    *
    * @param {Object} parsedResponse Parsed response.
    *
    * @returns {void}
    */
    notifyResponseParsed: function(parsedResponse) {
        this._fireEvent("notify:responseParser.responseParsed", parsedResponse);
    },

    /**
     * Saves a server response.
     *
     * @param {Object} parsedResponse Parsed response.
     * @param {Object} response Response.
     *
     * @returns {void}
     */
    storeNewServerResponse: function(parsedResponse, response) {
        Resources.storeData("gameServerInitResponse", Sys.utils.queryStringToObject(response.responseText));
        Resources.storeData("gameServerInitResponseObject", parsedResponse);
        Resources.storeData("unParsedGameServerInitResponse", response.responseText);
    },

    /**
    * Notify that reInit completed.
    *
    * @returns {void}
    */
    notifyReInitCompleted: function() {
        this._fireEvent("notify:integrationBalanceId.reInit");
    },

    /**
     * Handles parsed response from the server.
     *
     * @param {Object} parsedResponse Parsed response.
     * @param {Object} response Response.
     *
     * @returns {void}
     */
    onResponseParsed: function(parsedResponse, response) {
        this.storeNewServerResponse(parsedResponse, response);

        this.requestServicesReInit(parsedResponse);

        this.requestModulesReInit(parsedResponse);

        this.notifyResponseParsed(parsedResponse);

        this.notifyReInitCompleted();
    },

    /**
     * Sets balance id in arbitraryParameters.
     *
     * @param {string} newBalanceId New balance id.
     *
     * @returns {void} /.
     */
    setBalanceIdInArbitraryParameters: function(newBalanceId) {
        var arbitraryParameters = window.Resources.readData(
            "arbitraryParameters"
        ).toString();

        arbitraryParameters = arbitraryParameters.replace(
            /ne_balance_id=([^&]+)/,
            "ne_balance_id=" + newBalanceId
        );

        window.Resources.storeData("arbitraryParameters", arbitraryParameters);
    },

    /**
     * Request a new init action from serverManager.
     *
     * @returns {void}
     */
    requestInitAction: function() {
        this._fireEvent(
            "request:serverManager.sendAction",
            "init",
            "notify:integrationBalanceId.responseParsed"
        );
    },

    /**
     * Handles balance id update.
     *
     * @param {string} newBalanceId New balanceId.
     *
     * @returns {void}
     */
    handleUpdate: function(newBalanceId) {
        this.setBalanceIdInArbitraryParameters(newBalanceId);

        this.requestInitAction();
    }
};
